import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAos-jOo3_XaFowbKml2r6XjhsnOND66Vg",
  authDomain: "onyros-f1a79.firebaseapp.com",
  projectId: "onyros-f1a79",
  storageBucket: "onyros-f1a79.firebasestorage.app",
  messagingSenderId: "422474288710",
  appId: "1:422474288710:web:6dae5363533fa259b68447",
  measurementId: "G-929FXMMWM1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;